/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Fragment } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../component/controls/Controls";
import { useForm, Form } from "../../component/useForm";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import {  updateProfite } from "../../redux/profit";
import { updateCity } from "../../redux/cities";
function EditCity(props) {
  const dispatch = useDispatch();
  const { Cityid, loadingUpdate, loading } = useSelector(
    (state) => state.Cities
  );
  const initialFValues = {

    name_ar: "",
    name_en: "",
    address: "",
  };
  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  };
  useEffect(() => {
    if (Cityid) {
      resetForm(); // clear previous values
      setValues({
        id: Cityid.id,
        name_ar: Cityid.name_ar || "",
        name_en: Cityid.name_en || "",
        address: Cityid.address || "",
      });
    }
  }, [Cityid]);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name_ar" in fieldValues)
      temp.name_ar = fieldValues.name_ar ? "" : "هذا الحقل مطلوب";
    if ("name_en" in fieldValues)
      temp.name_en = fieldValues.name_en
    ? ""
    : "هذا الحقل مطلوب";
    if ("address" in fieldValues)
      temp.address = fieldValues.address ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });

    if (fieldValues === values) return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      dispatch(updateCity(values));
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {loading ? (
        <div className="spinner1-box">
          <svg class="spinner1" viewBox="0 0 50 50">
            <circle
              class="path1"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
      ) : (
        <Grid className="createdTrip">
          <Grid item xs={12} md={12} sm={12}>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row-reverse",
              }}
            >
              <Controls.Input
                InputLabelProps={{ shrink: true }} // Add this line
                className="tesr122"
                name="name_ar"
                label={
                  <Fragment>
                    <InputAdornment position="end">
                      <span className="placeholdertitle">الاسم بالعربي</span>
                    </InputAdornment>
                  </Fragment>
                }
                value={values.name_ar}
                onChange={handleInputChange}
                error={errors.name_ar}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row-reverse",
              }}
            >
              <Controls.Input
                InputLabelProps={{ shrink: true }} // Add this line
                className="tesr122"
                name="name_en"
                label={
                  <Fragment>
                    <InputAdornment position="end">
                      <span className="placeholdertitle">
                          الاسم بالإنجليزي  
                      </span>
                    </InputAdornment>
                  </Fragment>
                }
                value={values.name_en}
                onChange={handleInputChange}
                error={errors.name_en}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row-reverse",
              }}
            >
              <Controls.Input
                InputLabelProps={{ shrink: true }} // Add this line
                className="tesr122"
                name="address"
                label={
                  <Fragment>
                    <InputAdornment position="end">
                      <span className="placeholdertitle">
                          العنوان
                      </span>
                    </InputAdornment>
                  </Fragment>
                }
                value={values.address}
                onChange={handleInputChange}
                error={errors.address}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid xs={12} md={12}>
        {loadingUpdate ? (
          <div
            className="bottonFullwidth"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="load loadingupdate"
              style={{ background: "#F9B917", borderRaduis: "10px" }}
            >
              <div v-if="loading" class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="bottonFullwidth"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Controls.Button type="submit" text="تعديل" />
          </div>
        )}
      </Grid>
    </Form>
  );
}
export default EditCity;
